import React from 'react';
import { UtensilsCrossed, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-zinc-900 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-6">
              <span className="text-2xl font-bold tracking-tight text-white">
                House of <span className="text-amber-500">Falafel</span>
              </span>
            </div>
            <p className="text-zinc-400 max-w-md leading-relaxed">
              Autentisk mellemøstlig street food lavet fra bunden. Vi bringer smagen af tradition og friskhed direkte til dit næste arrangement.
            </p>
          </div>
          
          <div>
            <h3 className="text-white font-bold mb-6">Kontakt</h3>
            <ul className="space-y-4">
              <li className="flex items-center gap-3 text-zinc-400">
                <Phone className="h-5 w-5 text-amber-500" />
                <a href="tel:22907030" className="hover:text-white transition-colors">22 90 70 30</a>
              </li>
              <li className="flex items-center gap-3 text-zinc-400">
                <Mail className="h-5 w-5 text-amber-500" />
                <a href="mailto:houseoffalafel2023@icloud.com" className="hover:text-white transition-colors">houseoffalafel2023@icloud.com</a>
              </li>
              <li className="flex items-center gap-3 text-zinc-400">
                <MapPin className="h-5 w-5 text-amber-500" />
                <span>Find os i forretningen</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-6">Info</h3>
            <p className="text-zinc-400 text-sm">
              CVR: 44081652<br />
              © {new Date().getFullYear()} House of Falafel.<br />
              Alle rettigheder forbeholdes.
            </p>
          </div>
        </div>
        
        <div className="border-t border-zinc-900 pt-8 text-center">
          <p className="text-zinc-500 text-sm">
            Designet med fokus på autenticitet og kvalitet.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
